export default "__VITE_ASSET__DlVT$OGK__"